angular.module('CarsSaraBo').service('GeoCoder', ['$q', '$rootScope', function($q, $rootScope) {
    return {
      getLocations : function(address) {
        var deferred = $q.defer();
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({'address': address }, function (results, status) {
          $rootScope.$apply(function() {
            if (status == google.maps.GeocoderStatus.OK) {
              deferred.resolve(results);
            }
          });
        });
        return deferred.promise;
      }
    }
}]);



//////////////////
// WEBPACK FOOTER
// ./public/app/models/geo_coder.js
// module id = 848
// module chunks = 3